/**
 * compare-bootstrap.js — always-loaded lazy-loader.
 * Reads localStorage state, refreshes button visuals, and lazily injects
 * compare.js + compare.css the first time the user clicks any compare button
 * (or immediately for returning visitors who already have picks stored).
 *
 * The real drawer / bar logic lives in compare.js and is downloaded on demand.
 */
(function () {
  'use strict';
  var K = 'smt:compare:v1';
  var loading = false;
  var cssLoaded = false;
  var pending = [];

  function finishPending(replay) {
    var clicks = pending;
    pending = [];
    clicks.forEach(function (entry) {
      if (entry.busy === null) entry.button.removeAttribute('aria-busy');
      else entry.button.setAttribute('aria-busy', entry.busy);
      // Reuse the full bundle's existing toggle, limit, conflict and toast logic.
      if (replay && entry.button.isConnected) entry.button.click();
    });
  }

  function readState() {
    try {
      var raw = localStorage.getItem(K);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.v !== 1) return null;
      return parsed;
    } catch (e) { return null; }
  }

  function inject() {
    if (loading || window.SHTCompare) return;
    if (!window.SHT_COMPARE_JS) { finishPending(false); return; }
    loading = true;
    if (!cssLoaded && window.SHT_COMPARE_CSS) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = window.SHT_COMPARE_CSS;
      document.head.appendChild(l);
      cssLoaded = true;
    }
    var s = document.createElement('script');
    s.src = window.SHT_COMPARE_JS;
    s.defer = true;
    s.onload = function () {
      loading = false;
      if (!window.SHTCompare) s.remove();
      finishPending(!!window.SHTCompare);
    };
    s.onerror = function () {
      loading = false;
      s.remove();
      finishPending(false);
      console.warn('[SHTCompare] Could not load comparison. Click again to retry.');
    };
    document.head.appendChild(s);
  }

  function refreshButtons() {
    var st = readState();
    var ids = new Set();
    if (st && Array.isArray(st.items)) {
      st.items.forEach(function (it) { if (it && it.id != null) ids.add(Number(it.id)); });
    }
    var btns = document.querySelectorAll('.js-btn-add-to-compare[data-product-id]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = ids.has(Number(b.dataset.productId));
      b.classList.toggle('is-in-compare', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  // Returning visitor with existing picks — load the full bundle right away
  var st = readState();
  if (st && st.items && st.items.length) inject();

  // Hold the first interaction until the lazy bundle has installed its handler.
  // Repeated clicks on one product while loading represent the same pending pick.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.js-btn-add-to-compare');
    if (!btn || !btn.dataset.productId || window.SHTCompare) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!pending.some(function (entry) { return entry.id === btn.dataset.productId; })) {
      pending.push({ button: btn, id: btn.dataset.productId, busy: btn.getAttribute('aria-busy') });
      btn.setAttribute('aria-busy', 'true');
    }
    inject();
  }, true);

  // Cross-tab sync
  window.addEventListener('storage', function (e) { if (e.key === K) refreshButtons(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshButtons);
  } else {
    refreshButtons();
  }

  // Expose refresh so compare.js can call it after mutations without duplicating logic
  window.SHTCompareRefreshBtns = refreshButtons;
})();
